import { render, staticRenderFns } from "./common-iframe.vue?vue&type=template&id=bbde1238&scoped=true&"
import script from "./common-iframe.vue?vue&type=script&lang=js&"
export * from "./common-iframe.vue?vue&type=script&lang=js&"
import style0 from "./common-iframe.vue?vue&type=style&index=0&id=bbde1238&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbde1238",
  null
  
)

export default component.exports